import { render, staticRenderFns } from "./ADStatusSelector.vue?vue&type=template&id=010ba2d6&scoped=true&"
import script from "./ADStatusSelector.vue?vue&type=script&lang=js&"
export * from "./ADStatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./ADStatusSelector.vue?vue&type=style&index=0&id=010ba2d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ba2d6",
  null
  
)

export default component.exports